/**
 * Event types every BTB Manager hook subscribes to. Appointment events re-plan the day; timeblock
 * events (spec 2026-10-13 §7) let a hand-placed cleaning, lunch or do-not-book block re-plan it
 * within a minute instead of at the nightly run. No imports: the System page uses this too.
 */
export const APPOINTMENT_EVENT_TYPES = ["APPOINTMENT_CREATED", "APPOINTMENT_UPDATED", "APPOINTMENT_CANCELLED", "APPOINTMENT_RESCHEDULED"] as const;
export const TIMEBLOCK_EVENT_TYPES = ["TIMEBLOCK_CREATED", "TIMEBLOCK_CANCELLED", "TIMEBLOCK_RESCHEDULED"] as const;
export const SUBSCRIBED_EVENT_TYPES = [...APPOINTMENT_EVENT_TYPES, ...TIMEBLOCK_EVENT_TYPES] as const;
export type SubscribedEventType = (typeof SUBSCRIBED_EVENT_TYPES)[number];

/** Subscribed types this hook has no enabled subscription for, in SUBSCRIBED_EVENT_TYPES order. */
export function missingEventTypes(hook: { subscriptions: { eventType: string; enabled: boolean }[] }): SubscribedEventType[] {
  const on = new Set(hook.subscriptions.filter((s) => s.enabled).map((s) => s.eventType));
  return SUBSCRIBED_EVENT_TYPES.filter((t) => !on.has(t));
}
